module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue.e5f450f9.jpg";